<!-- 无偿资料 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">无偿投稿文章</p>
		</div>

    <div class="upload-wrap" v-if="percentage === 0 && urlTemp.length === 0">
      <van-uploader class="upload-box" :after-read="afterRead" :accept="IMAGE_TEXT_UPLOAD_FILE_TYPE">
        <div class="upload-box">
          <img src="../assets/icon-2.png">
          点击上传WORD/PDF/压缩文件
        </div>
      </van-uploader>
    </div>
		<div class="free-articles-wrap" v-else>
			<img src="../assets/icon-40.png" class="free-articles-icon">
			<div class="free-articles-sidebar">
        <div class="free-articles-row-between" v-if="percentage < 100">
          <div class="free-articles-right">正在上传...</div>
        </div>
				<div class="free-articles-row-between" v-else>
					<div class="free-articles-left">
						<img src="../assets/icon-42.png">上传完成
					</div>
          <van-uploader v-if="urlTemp.length === 0" :after-read="afterRead" accept="*">
            <div class="free-articles-right">
              <img src="../assets/icon-41.png">重新上传
            </div>
          </van-uploader>
				</div>
        <van-progress :color="'#1FB759'" class="progress-bar-box" :percentage="percentage" :show-pivot="false" />
			</div>
		</div>

		<div class="textarea-wrap">
			<van-field class="textarea" v-model="params.title" rows="2" autosize type="textarea" maxlength="80"
				placeholder="请输入标题(必填)" show-word-limit />
		</div>

		<div class="tag-wrap">
			<img src="../assets/icon-3.png" class="tag-icon" v-if="params.label.length === 0">
			<div class="tag-list" v-if="params.label.length > 0">
				<div class="tag" v-for="(item, index) in params.label" :key="index">
					<img src="../assets/icon-3.png" class="tag-icon">
					<span>{{item}}</span>
					<van-icon name="cross" @click="delTag(index)" />
				</div>
			</div>
			<input type="text" class="input" :placeholder="`添加标签,以回车区分（必填，最多${tagMaxSize}个）`" v-model="tagTemp"
				@keyup.enter="addTags()" v-if="params.label.length < tagMaxSize" />
		</div>

		<div class="brief-introduction-wrap">
			<p class="brief-introduction-label">简介</p>
			<div class="brief-introduction-textarea-box">
				<van-field class="brief-introduction-textarea" v-model="params.desc" rows="4" autosize type="textarea"
					maxlength="300" placeholder="请填写简介" show-word-limit />
			</div>
		</div>

		<div class="bottom-row">
			<a href="javascript:void(0)" @click="selected = !selected">
				<img src="../assets/circle-active.png" v-if="selected" class="circle-img">
				<img src="../assets/circle.png" v-else class="circle-img">
			</a>
			我已阅读并同意
			<span class="blue" @click="$router.push('/agreement?configKey=original_pact')">《GYXQCDZ原创公约》</span>
		</div>

		<div class="btn-box">
			<button type="button" class="active" @click="userReferVideo()">去投稿</button>
		</div>

	</div>
</template>

<script>
	import {
		validatorFun
	} from "@/common/util";
	import {
		Dialog,
		Toast
	} from "vant";
  import {
    ArticleService,
    uploadFile,
    VideoService
  } from "@/common/service";
  import {IMAGE_TEXT_UPLOAD_FILE_TYPE} from "@/common/config";

	export default {
		components: {},
		data() {
			return {
        IMAGE_TEXT_UPLOAD_FILE_TYPE,
				selected: true,

				tagMaxSize: 10,
				tagTemp: '',

        urlTemp: '',
				percentage: 0,

				params: {
          images: '', // 视频地址
					title: '', // 标题
					desc: '', // 简介
					label: [], // 视频标签id(多个用逗号隔开)
				}
			};
		},
		mounted() {
			this.init();
			window.addEventListener('unload', () => this.saveInput());
		},
		beforeDestroy() {
			this.saveInput(true);
		},
		destroyed() {
			window.removeEventListener('unload', () => this.saveInput());
		},
		methods: {
			init() {
				const option = this.$route.query;
				const id = parseInt(option.id || 0);
				if (id > 0) {
					ArticleService.getUserArticleDetail({
						id
					}).then(({
						data
					}) => {
						const {
							id,
							title,
							desc,
							label_name,
							images
						} = data.detail;
						this.params = {
							id,
							title,
							desc,
							images,
							label: label_name,
						};
						this.urlTemp = this.params.images;
						this.percentage = 100;
					});
				} else {
					const paramsStr = localStorage.getItem('free-articles-form');
					if (paramsStr) {
						Dialog.confirm({
							message: '发现有未提交的草稿，是否加载？',
						}).then(() => {
							try {
								this.params = JSON.parse(paramsStr);
								if (this.params.images.length > 0) {
									this.urlTemp = this.params.images;
									this.percentage = 100;
								}
							} catch (e) {}
						});
					}
					localStorage.removeItem('free-information-form');
				}
			},

			userReferVideo() {
				if (!this.selected) {
					return Toast('请阅读并同意《GYXQCDZ原创公约》');
				}
				const params = this.params;
				const errList = validatorFun(params, [
					['images', ['notNull', '请上传文件']],
					['title', ['notNull', '请输入标题']],
					['label', [label => label.length > 0, '请添加标签']],
					['desc', ['notNull', '请输入简介']],
				]);
				if (errList.length > 0) {
					return Toast(errList[0].errMsg);
				}
				ArticleService.userReferArticle({
					...params,
					label: params.label.join(',')
				}).then(({
					msg
				}) => {
					Toast(msg);
					this.params = {
						title: '', // 标题
						desc: '', // 简介
						images: '', // 视频地址
						label: [], // 视频标签id(多个用逗号隔开)
					};
					setTimeout(() => this.$router.push('/image-text-my-release'), 1500);
				});
			},

			afterRead({
				file,
				content
			}) {
				// 此时可以自行将文件上传至服务器
				this.urlTemp = content;
				uploadFile(file, ({
					loaded,
					total
				}) => {
					this.percentage = Math.min(parseFloat((loaded / total * 100).toFixed(2)), 99);
				}).then(({
					data
				}) => {
					this.urlTemp = data;
					this.params.images = data;
					this.percentage = 100;
				}).catch(() => {
					this.urlTemp = '';
					this.params.images = '';
					this.percentage = 0;
				});
			},
			addTags() {
				const tags = this.tagTemp.split(',').filter(str => str && str.length > 0);
				this.params.label = [...new Set([...this.params.label, ...tags])];
				this.tagTemp = '';
			},
			delTag(index) {
				this.params.label.splice(index, 1);
			},

			saveInput(showDialog = false) {
				const params = this.params;
				const errList = validatorFun(params, [
					['images', ['notNull', '请上传文件']],
					['title', ['notNull', '请输入标题']],
					['label', [label => label.length > 0, '请添加标签']],
					['desc', ['notNull', '请输入简介']],
				]);
				if (!params.id && errList.length < 4) {
					if (showDialog) {
						Dialog.confirm({
							title: '是否保存草稿？',
							confirmButtonColor: '#2A63F3',
							confirmButtonText: '保存草稿',
							cancelButtonText: '不保存',
						}).then(() => {
							localStorage.setItem('free-information-form', JSON.stringify(params));
						});
					} else {
						localStorage.setItem('free-information-form', JSON.stringify(params));
					}
				}
			},
		}
	}
</script>

<style scoped>
	.wrap {
		min-height: 100vh;
		background-color: #F4F4F4;
	}

	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 44px 15px 15px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.upload-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		border-radius: 12px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);
		margin: 10px 0;
	}

	.upload-box {
		width: 100%;
		height: 194px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #333333;
		font-size: 15px;
	}

	.upload-box>img {
		width: 30px;
		margin-bottom: 10px;
	}

	.video-box {
		width: 100%;
		height: 194px;
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		background-color: #ccc;
	}

	.video-box video {
		width: 100%;
	}

	.re-upload {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		color: #FFFFFF;
		font-size: 10px;
	}

	.re-upload-box {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.re-upload img {
		width: 30px;
		margin-bottom: 4px;
	}

	.progress-bar {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: absolute;
		left: 0;
		bottom: 8px;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.progress-label {
		color: #FFFFFF;
		font-size: 13px;
	}

	.textarea-wrap {
		width: 100%;
		min-height: 80px;
		display: flex;
		flex-direction: column;
		border-radius: 16px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);
		margin-bottom: 10px;
		padding: 10px;
		box-sizing: border-box;
	}

	.textarea {
		width: 100%;
		border: none;
		resize: none;
		font-size: 16px;
		padding: 0;
	}

	.textarea::placeholder {
		color: #7F7F7F;
	}

	.flex-end-text {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.tag-wrap {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		border-radius: 16px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);
		margin-bottom: 10px;
		padding: 10px;
		box-sizing: border-box;
	}

	.tag-icon {
		width: 18px;
	}

	.tag-list {
		width: max-content;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list .tag {
		width: max-content;
		height: 24px;
		display: flex;
		align-items: center;
		border-radius: 12px;
		background: #F8F8F8;
		color: #2A63F3;
		font-size: 14px;
		padding-right: 5px;
		margin-right: 5px;
	}

	.tag-list .tag .tag-icon {
		width: 18px;
		height: 22px;
		border: 3px solid #FFFFFF;
		border-radius: 12px;
		margin: 0;
	}

	.input {
		min-width: 80%;
		height: 44px;
		flex: 1;
		font-size: 14px;
		display: inline-block !important;
		word-wrap: break-word !important;
		word-break: break-all !important;
		overflow: hidden !important;
		padding-left: 8px;
	}

	.input::placeholder {
		color: #7F7F7F;
	}

	.brief-introduction-wrap {
		width: 100%;
		min-height: 80px;
		display: flex;
		flex-direction: column;
		border-radius: 16px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);
		margin-bottom: 10px;
		padding: 8px 10px 14px;
		box-sizing: border-box;
	}

	.brief-introduction-label {
		color: #333333;
		font-size: 16px;
	}

	.brief-introduction-textarea-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #F3F3F3;
		border-radius: 16px;
		padding: 10px;
		box-sizing: border-box;
		margin-top: 6px;
	}

	.brief-introduction-textarea {
		width: 100%;
		height: 136px;
		overflow: auto;
		border: none;
		resize: none;
		background-color: initial;
		font-size: 12px;
		padding: 0 0 16px;
		box-sizing: border-box;
	}

	.brief-introduction-textarea>>>.van-field__word-limit {
		position: absolute;
		bottom: -16px;
		right: 0;
	}

	.brief-introduction-textarea-box>>>.van-field__control {
		height: 120px !important;
	}

	.brief-introduction-textarea::placeholder {
		color: #7F7F7F;
	}

	.bottom-row {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 60px;
		color: #9C9C9C;
		font-size: 12px;
		padding: 0 25px;
		box-sizing: border-box;
	}

	.circle-img {
		width: 12px;
		margin-right: 6px;
	}

	.blue {
		color: #2A63F3;
	}

	.btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0 22px;
	}

	.btn-box>button {
		width: 100%;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
		border-radius: 100px;
		background-color: #8AABFF;
	}

	.btn-box>button.active {
		background-color: #2A63F3;
	}

	.free-articles-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);
		padding: 13px 8px 22px 11px;
		box-sizing: border-box;
		border-radius: 16px;
		margin: 12px 0 10px;
	}

	.free-articles-icon {
		width: 30px;
		margin-right: 12px;
	}

	.free-articles-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.free-articles-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.free-articles-left {
		display: flex;
		align-items: center;
		color: #1FB759;
		font-size: 12px;
	}

	.free-articles-left>img {
		width: 14px;
		margin-right: 2px;
	}

	.free-articles-right {
		display: flex;
		align-items: center;
		color: #0054F7;
		font-size: 12px;
	}

	.free-articles-right>img {
		width: 12px;
		margin-right: 4px;
	}

	.progress-bar-box {
		margin-top: 13px;
	}
</style>
